import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "table-header-item-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_TableHeader = _resolveComponent("TableHeader")!
  const _component_TextHighlights = _resolveComponent("TextHighlights")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_SingleFilter = _resolveComponent("SingleFilter")!
  const _component_FilterDrawer = _resolveComponent("FilterDrawer")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table_server, {
                "sort-by": _ctx.sortBy,
                "onUpdate:sortBy": [
                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sortBy) = $event)),
                  _ctx.onSortByChanged
                ],
                headers: _ctx.headers,
                items: _ctx.teilnehmerList,
                loading: _ctx.loading,
                "items-length": _ctx.totalNumberOfRecords || 0,
                "must-sort": true,
                "item-value": "kundenNummer",
                hover: "",
                "hide-default-footer": "",
                class: "elevation-1 nowhow-table"
              }, {
                top: _withCtx(() => [
                  _createVNode(_component_TableHeader, {
                    filters: _ctx.filters,
                    onChipClosed: _ctx.removeFilter
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.totalNumberOfRecords + ' ' + _ctx.$t('archiv.table.header.items')), 1),
                      (_ctx.showSearchBar)
                        ? (_openBlock(), _createBlock(_component_v_text_field, {
                            key: 0,
                            modelValue: _ctx.filterData.suchText,
                            "onUpdate:modelValue": [
                              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterData.suchText) = $event)),
                              _ctx.searchFieldInputChanged
                            ],
                            class: "ml-5",
                            "prepend-inner-icon": "mdi-magnify",
                            "append-inner-icon": "mdi-close",
                            label: _ctx.$t('suche'),
                            "hide-details": "",
                            autofocus: "",
                            "onClick:appendInner": _ctx.searchBarClosed
                          }, null, 8, ["modelValue", "label", "onUpdate:modelValue", "onClick:appendInner"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_spacer),
                      (!_ctx.showSearchBar)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 1,
                            top: "",
                            color: "secondary"
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn, _mergeProps(props, {
                                icon: "",
                                color: "primary"
                              }), {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSearchBar = !_ctx.showSearchBar))
                                  }, {
                                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                                      _createTextVNode("mdi-magnify")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('tableheader.tooltip.search')), 1)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_tooltip, {
                        top: "",
                        color: "secondary"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps(props, {
                            icon: "",
                            color: "primary",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilterDrawer = !_ctx.showFilterDrawer))
                          }), {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                  _createTextVNode("mdi-filter-outline")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('tableheader.tooltip.filter')), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["filters", "onChipClosed"])
                ]),
                "item.kundenNummer": _withCtx(({ item }) => [
                  _createVNode(_component_TextHighlights, {
                    text: item.kundenNummer,
                    "search-text": _ctx.filterData.suchText
                  }, null, 8, ["text", "search-text"])
                ]),
                "item.firma": _withCtx(({ item }) => [
                  _createVNode(_component_TextHighlights, {
                    text: item.firma,
                    "search-text": _ctx.filterData.suchText
                  }, null, 8, ["text", "search-text"])
                ]),
                "item.plz": _withCtx(({ item }) => [
                  _createVNode(_component_TextHighlights, {
                    text: item.plz + ' ' + item.ort,
                    "search-text": _ctx.filterData.suchText
                  }, null, 8, ["text", "search-text"])
                ]),
                "item.teilnehmerStatusCode": _withCtx(({ item }) => [
                  _createTextVNode(_toDisplayString(_ctx.$t(item.teilnehmerStatusCode)), 1)
                ]),
                "item.burgermenu": _withCtx(({ item }) => [
                  _createVNode(_component_v_btn, {
                    icon: "",
                    href: item.burgermenu,
                    flat: "",
                    onClick: ($event: any) => (_ctx.initTakeSpecific(item.teilnehmerId))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: "primary",
                        icon: "mdi-account-cog"
                      })
                    ]),
                    _: 2
                  }, 1032, ["href", "onClick"])
                ]),
                _: 1
              }, 8, ["sort-by", "headers", "items", "loading", "items-length", "onUpdate:sortBy"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_FilterDrawer, {
        visible: _ctx.showFilterDrawer,
        onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cancelFilter())),
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmFilter())),
        onReset: _cache[7] || (_cache[7] = ($event: any) => (_ctx.resetFilter()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SingleFilter, {
            title: _ctx.$t('taketeilnehmer.table.header.status')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { sm: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.filterData.status,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterData.status) = $event)),
                        filled: "",
                        dense: "",
                        "hide-details": "",
                        items: _ctx.status
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }))
}